import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import PurchaseMyTheaterInstructions from './PurchaseMyTheaterInstructions.vue';
import ExpansionPanel from '~/components/Collections/ExpansionPanel.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyTheaterHeader',
  setup(__props) {

const purchaseInstructionCollapsed = ref<boolean>(false);

function onExpansionChange(event: Event) {
  purchaseInstructionCollapsed.value = event ? true : false;
}

return { __sfc: true,purchaseInstructionCollapsed, onExpansionChange, PurchaseMyTheaterInstructions, ExpansionPanel }
}

})